import React__default from 'react';
import { Wrapper, Text, Blocks as Blocks$1, Block, Number, String } from './Blocks.styles.js';

var CountdownTimer = function CountdownTimer(_ref) {
  var timeLeft = _ref.timeLeft,
    text = _ref.text;
  var days = timeLeft.days,
    hours = timeLeft.hours,
    minutes = timeLeft.minutes;
  var dayString = "day".concat(days !== 1 ? 's' : '');
  var hourString = "hour".concat(hours !== 1 ? 's' : '');
  var minuteString = "min".concat(minutes !== 1 ? 's' : '');
  var showDays = days > 0;
  var showHours = hours > 0;
  var showMinutes = minutes > 0;
  return /*#__PURE__*/React__default.createElement(Wrapper, null, text && /*#__PURE__*/React__default.createElement(Text, null, text), /*#__PURE__*/React__default.createElement(Blocks$1, null, showDays && /*#__PURE__*/React__default.createElement(Block, {
    className: "countdown-block"
  }, /*#__PURE__*/React__default.createElement(Number, null, days), ' ', /*#__PURE__*/React__default.createElement(String, null, dayString)), showHours && /*#__PURE__*/React__default.createElement(Block, {
    className: "countdown-block"
  }, /*#__PURE__*/React__default.createElement(Number, null, hours), ' ', /*#__PURE__*/React__default.createElement(String, null, hourString)), showMinutes && /*#__PURE__*/React__default.createElement(Block, {
    className: "countdown-block"
  }, /*#__PURE__*/React__default.createElement(Number, null, minutes), ' ', /*#__PURE__*/React__default.createElement(String, null, minuteString))));
};
var Blocks = CountdownTimer;

export { Blocks as default };
//# sourceMappingURL=index.js.map
